import type { EndpointDefinition } from "../../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    updatePaymentMethod: {
        route: "/workspaces/:workspaceId/billing/payment-method",
        method: "POST"
    }
};
